var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26919",
    "data-name": "Group 26919",
    transform: "translate(-13336 8462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6211",
    "data-name": "Rectangle 6211",
    transform: "translate(13336 -8462)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_53",
    "data-name": "Union 53",
    d: "M-15423.329-24776.8a.678.678,0,0,1-.672-.678v-2.937a.668.668,0,0,1,.2-.479l4.324-4.324v-.006a4.4,4.4,0,0,1-.118-.883,4.9,4.9,0,0,1,4.9-4.9,4.906,4.906,0,0,1,4.9,4.9,4.907,4.907,0,0,1-4.9,4.9,4.65,4.65,0,0,1-1.344-.213v.641a.676.676,0,0,1-.672.68h-1.164v1.156a.678.678,0,0,1-.672.678h-1.163v.791a.678.678,0,0,1-.672.678Zm6.122-11.82a3.532,3.532,0,0,0-1.039,2.514,3.52,3.52,0,0,0,.131.945.672.672,0,0,1-.168.658l-4.367,4.369v1.984h1.586v-.8a.675.675,0,0,1,.679-.672h1.157v-1.164a.674.674,0,0,1,.678-.672h1.157v-.939a.685.685,0,0,1,.336-.584.7.7,0,0,1,.666-.014,3.486,3.486,0,0,0,1.692.436,3.506,3.506,0,0,0,2.514-1.039,3.521,3.521,0,0,0,1.039-2.512,3.532,3.532,0,0,0-1.039-2.514,3.533,3.533,0,0,0-2.514-1.033A3.519,3.519,0,0,0-15417.207-24788.617Zm2.022,1.779a1.227,1.227,0,0,1,1.22-1.227,1.229,1.229,0,0,1,1.226,1.227,1.224,1.224,0,0,1-1.226,1.225A1.222,1.222,0,0,1-15415.185-24786.838Z",
    transform: "translate(28760.9 16329.898)",
    fill: "#314469"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.654aea87a3e55a88e8843c545ea601c7.svg";
export { ForwardRef as ReactComponent };